//! Silversea

import allSettled from "promise.allsettled";
import { initOneTrust } from "./utils/onetrust";
import { SilverseaVisitor } from "./utils/silverseaVisitor";
import { iniTrackingRollbar, rollbarError } from "./utils/rollbarErrors";
import { exposeGlobals } from "./global";
import { getLCP, getFID, getCLS, getFCP, getTTFB } from "web-vitals";
import { ContentInteraction } from "./utils/interfaces";

interface EventDetail extends Event {
  detail: any; // eslint-disable-line
}

interface EventData extends Event {
  data: any; // eslint-disable-line
}

try {
  wspr;
} catch (e) {
  const whispers_js_script = document.createElement("script");
  whispers_js_script.innerHTML =
    'window.wspr=window.wspr||(()=>{let f=Object.entries,i=Date.now,n={T:{},s:{},x:Math.floor(1e18*Math.random()),V:!1,Y:!1,A:!1,E:async(r,s)=>{s.W=s.W||{};for(var[e,t]of f(n.s[r]||[]))s.W[e]=s.W[e]||{G:!1,H:0,M:0};let l=!0;var o=[];for(let[e,a]of f(s.W||{}))o.push((async()=>{let t;if(a.G)t=!0;else{a.D=i();try{t=!0===await n.s[r][e].Q(s)}catch(e){t=!1,a.M++,a.L=JSON.stringify(e)}a.J=i(),a.H++,a.F=a.F||a.D}a.G=t,l&=t})());return await Promise.allSettled(o),s.N=l,s},I:async()=>{if(n.Y)n.A=!0;else{n.Y=!0;for(let[a,r]of f(n.T)){var s=[];for(let[t,e]of f(r.e))s.push((async()=>{await n.E(a,e).then(e=>{e.N&&n.V&&delete r.e[t]})})());await Promise.allSettled(s)}n.Y=!1,n.A&&(n.A=!1,n.I())}},P:(e,t)=>{n.T[e]=n.T[e]||{C:0,e:{}};var a=n.x+"."+n.T[e].C++;n.T[e].e[a]={id:a,f:i(),m:t},n.I()},S:(e,t,a,r)=>{n.s[e]=n.s[e]||{},r=!0===r,n.s[e][t]={Q:a,U:r},n.P("#",{e:"S",O:e,w:t,U:r}),n.I()},R:()=>{n.V=!0,n.P("#",{e:"R"})}};return n.P("#",{e:"I"}),n})();';
  document.getElementsByTagName("head")[0].appendChild(whispers_js_script);
  console.log("wspr was added, because it was not found to be initialised.");
}

allSettled.shim();

// WHISPERSJS EVENT LISTENER PUBLISHERS START HERE
// ...............................................
// just publish these events to WhispersJS so they are stored and ready for subscribers
// this also means any uncaught errors while the subscribers are processing are logged

// Because sometimes the analytics library loads after bla bla bla, see below... (first_pageload_triggered)
window.addEventListener("consent.onetrust", (event: any) => {
  wspr.P("onetrust", event.detail);
});
// load the onetrust library
initOneTrust();

// Because sometimes the analytics library loads after the pageload event has already fired
// We need to track if the pageload has been missed. So we are using this boolean. If later
// we detect the first_pageload_triggered is still false, then we will publish a pageload
// using data from the datalayer.
// NOTE: once WhispersJS is implemented in other scripts, we won't need to do this,
// as the event will not get lost.
let first_pageload_triggered = false;
window.addEventListener("page-view-tracking-data-available", (event: any) => {
  first_pageload_triggered = true;
  wspr.P("pageload_raw", event);
  // console.log("PAGELOAD FROM EVENT");
});
window.addEventListener("cruise-filters-changed", (event: EventDetail) => {
  wspr.P("cruise_filters_changed", event);
});
window.addEventListener(
  "web-request-submitted",
  (original_event: EventDetail) => {
    debug("web-request-submitted", "EVENT TRIGGERED");
    // make a copy of the event
    const event = { ...original_event.detail };
    wspr.P("web_request_submitted_raw", event);
  }
);
window.addEventListener(
  "click",
  (elem: Event) => {
    const clicked_element = elem?.target as HTMLElement; // & { innerText: String, closest: Function}
    const closest_data_content_piece_elem = clicked_element?.closest(
      "[data-content-piece]"
    ) as HTMLElement;
    if (closest_data_content_piece_elem) {
      const data_content_attribs = get_data_content_attribs(
        closest_data_content_piece_elem
      );
      data_content_attribs.event_type = "click";

      if (data_content_attribs["data-content-params"] == null) {
        const inner = clicked_element?.innerText || "";
        data_content_attribs["data-content-params"] = {
          innerText: inner.substring(0, 25)
        };
      }
      log("tracking_listener", data_content_attribs);

      const closest_ab_segment_elem = clicked_element?.closest(
        "[abtest-experiment]"
      );
      if (closest_ab_segment_elem) {
        data_content_attribs["data-content-ab-component-test"] =
          sv.get_ab_test_component_vals(closest_ab_segment_elem);
      }

      wspr.P("click_interaction", data_content_attribs);
    }

    const accept_specific_consent_buttons = Array.from(
      document.getElementsByClassName("save-preference-btn-handler")
    );

    for (const el of accept_specific_consent_buttons) {
      if (el?.contains(clicked_element)) {
        // console.log("CONSENT!! -> ACCEPT SPECIFIC");
        sv.onetrust_consent.set_attitude("accepted specific");
        wspr.P("consent_settings", sv.onetrust_consent.get_consent());
      }
    }

    const accept_all_consent_buttons = [
      document.getElementById("onetrust-accept-btn-handler"),
      document.getElementById("accept-recommended-btn-handler")
    ];

    for (const el of accept_all_consent_buttons) {
      if (el?.contains(clicked_element)) {
        // console.log("CONSENT!! -> ACCEPT ALL");
        sv.onetrust_consent.set_attitude("accepted all");
        wspr.P("consent_settings", sv.onetrust_consent.get_consent());
      }
    }

    const close_buttons = Array.from(
      document.getElementsByClassName("banner-close-button")
    ).concat([document.getElementById("close-pc-btn-handler")]);

    for (const el of close_buttons) {
      if (el?.contains(clicked_element)) {
        // console.log("CONSENT!! -> REJECT");
        sv.onetrust_consent.set_attitude("reject");
        wspr.P("consent_settings", sv.onetrust_consent.get_consent());
      }
    }
  },
  {
    capture: true
  }
);
// this is used for getting messages from iframes and translaing them appropriately
window.addEventListener("message", (event: EventData) => {
  const context = "message";
  try {
    // Get the sent data
    const data = event.data;
    // console.log("PARENT: " + data);
    if (typeof data == "string") {
      try {
        const data_obj = JSON.parse(data);
        if (data_obj["data-type"] == "click-content-interaction") {
          wspr.P("silversea_event", {
            type: "message",
            details: event
          });
          wspr.P("click_interaction", data_obj.data);
        }
      } catch (exptn) {
        log(context, "Error in JSON: " + exptn.toString());
      }
    }
  } catch (e) {
    rollbarError("EVENT LISTENER IS :> message", e);
  }
});

let last_scroll_pos=-1;

const scroll_func = (event?: Event) => {
  try {
    const docHeight = Math.max( 
        document.body.scrollHeight, 
        document.body.offsetHeight, 
        document.documentElement.clientHeight, 
        document.documentElement.scrollHeight, 
        document.documentElement.offsetHeight 
    )

    let scroll_pos = 100;

    if (docHeight != 0) {
      scroll_pos = Math.floor(Math.ceil(window.scrollY)/(docHeight-window.innerHeight)*4)*25 
    }

    if (scroll_pos > last_scroll_pos && scroll_pos != 0) {
      wspr.P("scroll", scroll_pos);
      last_scroll_pos=scroll_pos;
    }
  } catch (e) {
    rollbarError("EVENT LISTENER IS :> message", e);
  }
}

document.addEventListener("scroll", scroll_func);

// WHISPERSJS EVENT LISTENER PUBLISHERS END HERE
// .............................................

// WHISPERSJS SUBSCRIBER FUNCTIONS HERE
// ....................................
const onetrust_func = (wspr_event) => {
  const event = wspr_event.m;

  const context = "consent.onetrust";
  try {
    debug(context + " -> EVENT TRIGGERED", event);

    try {
      sv.onetrust_consent.set_from_onetrust_event(event);
      console.log('Set from onetrust event');
    } catch (e) {
      try {
        console.log('Set from onetrust cookie');
        // sometimes the event details are empty!! you need to get them from the cookie...
        sv.onetrust_consent.set_from_onetrust_cookie();
      } catch (e) {
        // if both fail, the default setting will remain
        console.log('Set from default');
      }
    }

    if (!sv.onetrust_consent.has_started) {
      post_consent_setup()
    }

    sv.onetrust_consent.has_started = true;

    log(
      context + " -> Consent Settings",
      sv.onetrust_consent.get_consent_json()
    );

    if (sv.onetrust_consent.consent_has_changed_since_initial_pageload()) {
      setTimeout(()=>{location.reload()}, 250);
    }
  } catch (e) {
    rollbarError("EVENT LISTENER IS :> consent.onetrust", e);
  }

  return true;
};

function get_data_content_attribs(elem: HTMLElement): ContentInteraction {
  const content_piece = elem?.getAttribute("data-content-piece");

  const name_array = [];
  let parent_elem = elem?.closest("[data-content-name]");

  while (parent_elem) {
    name_array.push(parent_elem.getAttribute("data-content-name"));
    parent_elem = parent_elem.parentElement.closest("[data-content-name]");
  }

  const content_name = name_array.reverse().join(">");

  if (content_name === "") {
    try {
      throw new Error(
        "data-content-name is required for content_piece '" +
          content_piece +
          "'"
      );
    } catch (e) {
      rollbarError("DATA-CONTENT-NAME Missing", e);
    }
    return undefined;
  }

  const content_target =
    elem?.closest("[href]")?.getAttribute("href") ||
    elem?.getAttribute("data-content-target");
  const content_params_str = elem?.getAttribute("data-content-params");
  const content_params = content_params_str
    ? JSON.parse(content_params_str)
    : null;

  // if (content_params) {
  //   content_params = JSON.parse(content_params);
  // } else {
  //   content_params = undefined;
  // }
  // content_params = null;

  // the click is applied to a whole navigation menu rather than an individual item in the navigation menu.
  let data_content_value = "NAV";

  if (elem.tagName != "NAV") {
    data_content_value = elem.innerText || elem.textContent;

    if (data_content_value) {
      data_content_value = data_content_value.split("\n")[0];
    } else {
      data_content_value = undefined;
    }
  }

  return {
    "data-content-name": content_name,
    "data-content-piece": content_piece,
    "data-content-target": content_target,
    "data-content-params": content_params,
    "data-content-value": data_content_value
  };
}

const enrich_pageload_with_datalayer = (evnt) => {
  const context = "enrich_pageload_with_datalayer()";
  debug(context, "EVENT TRIGGERED");

  // need to account for the blog which does not setup page categories the same as the main site.
  if (document.domain == "discover.silversea.com") {
    const blog_cat1 = sv.get_page_cat1() || "blog";
    const blog_cat2 = sv.get_page_cat2() || "blog";
    window.dataLayer.push({
      page_cat1: blog_cat1,
      page_cat2: blog_cat2
    });
  }

  window.dataLayer.push({
    page_type: sv.map_page_type(sv.get_page_cat1())
  });

  if (sv.onetrust_consent.targeting) {
    sv.set_conversion_path();
  }

  const data = evnt?.detail ? evnt.detail : evnt;

  log(context + " -> EVENT DETAILS RECIEVED", data);
  const page_details = {
    track_current_page: data.track_current_page || sv.get_track_current_page(),
    is_transcoded_version: data.is_transcoded_version ?? sv.get_experiment_layout_status(),
    page_cat1: data.page_cat1 || sv.get_page_cat1(),
    page_cat2: data.page_cat2 || sv.get_page_cat2(),
    track_page_type: data.track_page_type || sv.get_page_type(),
    user_language: data.user_language || sv.get_user_language(),
    user_country: data.user_country || sv.get_user_country(),
    user_geo_adwords:
      data.user_geo_adwords ||
      sv.get_platform_market() ||
      sv.lookup_platform_market(data.user_country),
    my_silversea: {
      env: data.custom_env || sv.get_my_silversea_vals()?.env,
      usertype: data.custom_usertype || sv.get_my_silversea_vals()?.usertype,
      individual_id:
        data.individual_id || sv.get_my_silversea_vals()?.individual_id
    }
  };
  if (data.voyage_details || sv.get_voyage_details()) {
    debug(context, "voyage_details detected...");
    page_details["voyage_details"] =
      data.voyage_details || sv.get_voyage_details();
    page_details["ab_test"] = data.ab_test || sv.get_ab_test();
  } else {
    debug(context, "no voyage_details detected...");
  }
  debug(context + " -> EVENT DETAIL", page_details);
  window.dataLayer.push(page_details);

  // WHISPERSJS will be able to replace this horrible dataLayerBackup hack soon.
  // Note this is a shallow copy
  // so will keep a backup list of objects
  // but if those objects are mutated in window.dataLayer they will also be mutated
  // in window.dataLayerBackup
  // But if the objects are just removed from window.dataLayer, they will still remain
  // in the window.dataLayerBackup list.
  // This should protect from another program removing elements from the window.dataLayer
  // Or re-assigning the window.dataLayer, which logs seem to indicate may be the case.
  window.dataLayerBackup = Array.from(window.dataLayer || []);
  window.dataLayerBackup.push(page_details);

  if (!sv.get_page_cat1()) {
    sv.log("Calling get_page_cat1 -> ", sv.get_page_cat1());
    rollbarError(
      "page_cat_1 detection",
      new Error(
        "page_cat1 is not set! dataLayer: " + JSON.stringify(window.dataLayer)
      )
    );
  }

  return page_details;
};

// WHISPERSJS SUBSCRIBER FUNCTIONS FINISH HERE
// ...........................................

try {
  window.ss_show_logs =
    (new URLSearchParams(window.location.search)
      ?.get("show_logs")
      ?.toLowerCase() ||
      sessionStorage.getItem("ss_show_logs")?.toLowerCase() ||
      "false") != "false" || window.ss_debug_mode;
  sessionStorage.setItem("ss_show_logs", `${window.ss_show_logs}`);
  const country = new URLSearchParams(window.location.search).get("country");

  if (window.ss_show_logs) {
    console.log(
      "%c *                 *   )  *\n" +
        "   ___| \\______|\\___    *  \n" +
        "  /:::::::::::::::::\\____  \n" +
        "~~\\           Silversea /~~\n" +
        "~~~~~~~~~~~~~~~~~~~~~~~~~~~%c\n\n" +
        "ss_debug_mode (gtm_debug) = %s\n" +
        "ss_show_logs = %s\n" +
        "country = %s\n",
      "background-color: #323234; color: #fcfcfd; font-size: 2em;",
      "padding: 0.5em; border-left: 1px solid #323234;",
      window.ss_debug_mode,
      window.ss_show_logs,
      country
    );
  }
} catch (e) {
  console.error(e);
}

function init_web_vitals(): void {
  const pub = (metric) => {
    wspr.P("web_vitals", metric);
  };
  getCLS(pub);
  getFID(pub);
  getLCP(pub);
  getFCP(pub);
  getTTFB(pub);
}

function log(context, message): void {
  if (window.ss_show_logs) {
    console.log(
      "%c%s%c%s -> ",
      "background-color: darkorange; padding: 0.5em;",
      String.fromCharCode(187),
      "background-color: black; color: #ADFF2F; padding: 0.5em; font-family: monospace;",
      context,
      message
    );
  }
}

function debug(context, message): void {
  if (window.ss_show_logs) {
    console.debug(
      "%c%s%c%s -> ",
      "background-color: darkorange; padding: 0.5em;",
      String.fromCharCode(187),
      "background-color: black; color: #ADFF2F; padding: 0.5em; font-family: monospace;",
      context,
      message
    );
  }
}

async function listen_for_dom_mutations() {
  // This gets called when the DOM get changed, it allows tracking to still work when the page elements
  // are changed dynamically by something like gatsby
  const dom_mutated_callback = async function (_mutationList, _observer) {
    try {
      // only trigger if product impressions increase on current page view,
      // otherwise the product impressions are dealt with by the page view function.
      if (sv.providers.google_analytics.product_impressions.size > 0) {
        sv.providers.google_analytics.scan_for_product_impressions();
      }

      // // this prevents an infinate loop if the dom is constantly updating (such as a clock or something)
      // // clicking something that generates a form will likely be tracked and should cause a scan by
      // // setting is_looping to false.
      // // there is probably a better way to do this but it should do for now.
      // if (sv.providers.matomo.has_started) {
      //   let is_looping = false;
      //   if (Array.isArray(_paq)) {
      //     const sample = _paq.slice(_paq.length - 5);
      //     const scanforms = "FormAnalytics::scanForForms";
      //     is_looping =
      //       scanforms == sample[0] &&
      //       scanforms == sample[1] &&
      //       scanforms == sample[2] &&
      //       scanforms == sample[3] &&
      //       scanforms == sample[4];
      //   }

      //   if (!is_looping) {
      //     _paq.push(["FormAnalytics::scanForForms"]);
      //   }
      // }
    } catch (e) {
      rollbarError("EVENT LISTENER IS :> dom_mutated_callback", e);
    }
  };

  // Setup a callback to trigger if any DOM changes are made.
  const targetNode = document;
  const observerOptions = {
    childList: true,
    attributes: true,
    subtree: true
  };
  const observer = new MutationObserver(await dom_mutated_callback);
  observer.observe(targetNode, observerOptions);
}

exposeGlobals();
window.trackingRollbar = iniTrackingRollbar();

init_web_vitals();

sv = new SilverseaVisitor();

function post_consent_setup() {
  wspr.P("consent_settings", sv.onetrust_consent.get_consent());
  sv.post_consent_init();
  sv.log("starting auid_pipeline_run", "");
  sv.auid_pipeline_run();
}

// waiting for the onetrust event can take many seconds!
// get the consent settings from the cookie or fall back to waiting for the onetrust event
try {
  // exception thrown if no onetrust cookie found
  sv.onetrust_consent.set_from_onetrust_cookie();
  sv.onetrust_consent.consent_has_changed_since_initial_pageload();
  sv.onetrust_consent.has_started = true;
  post_consent_setup()
} catch (e) {
  // wait for onetrust event
}

wspr.S("onetrust", "analytics_init", onetrust_func);
// Removed because Universal Analytics has been deprecated
// wspr.S("web_vitals", "analytics_init", (wspr_event) => {
//   const metric = wspr_event.m;
//   if (
//     sv.providers.google_analytics.has_started &&
//     sv.providers.google_analytics.has_consent_to_run
//   ) {
//     wspr.P("gtag", [
//       "event",
//       metric.name,
//       {
//         send_to: "UA-5494850-14",
//         event_category: "Web Vitals",
//         value: Math.round(
//           metric.name === "CLS" ? metric.delta * 1000 : metric.delta
//         ),
//         event_label: metric.id,
//         non_interaction: true
//       }
//     ]);
//   }
//   return true;
// });
wspr.S("pageload_raw", "analytics_init", (wspr_event) => {
  first_pageload_triggered = true;
  const enriched_pageload = enrich_pageload_with_datalayer(wspr_event.m);
  if (enriched_pageload) {
    // pageload logic start
    sv.pageloads_done += 1;
    const pageload_num = sv.pageloads_done;
    wspr.P("pageload", enriched_pageload);
  }
  scroll_func();
  return true;
});

function host_has_wspr_setup() {
  const hosts_with_wspr_setup = new Set(["www.silversea.com", "quote.silversea.com", "qa.ecommerce.digital.silversea.com"]);
  return hosts_with_wspr_setup.has(window.location.hostname);
}

function try_pageload() {
  if (host_has_wspr_setup()) {
    sv.log("wspr detected as setup. Fallback procedure not required.", null);
  } else {
    sv.log(
      "wspr detected as not fully setup for this host, using fallback procedure",
      null
    );
    window.setTimeout(() => {
      if (first_pageload_triggered) {
        // console.log(`Pageload Scheduled. P1. ${first_pageload_triggered}`)
        // pageload has already been dealt with
        return;
      } else if (sv.get_page_cat1() || sv.get_user_country()) {
        // console.log(`Pageload Scheduled. P2. ${first_pageload_triggered}`)
        // Looks like pageload has not been dealt with, but data is ready
        // trigger pageload now
        first_pageload_triggered = true;
        wspr.P("pageload_raw", enrich_pageload_with_datalayer({}));
        // console.log("PAGELOAD FROM FALLBACK");
      } else {
        // console.log(`Pageload Scheduled. P3. ${first_pageload_triggered}`)
        // Looks like pageload has not been dealt with, and data is not yet ready
        // try again shortly

        try_pageload();
      }
    }, 200);
  }
}

try_pageload();

// DataLayer Subscribers for GTM
wspr.S("pageload", "gtm_datalayer_events", async (wspr_event) => {
  const event = wspr_event.m;
  sv.trigger_event("pageload", undefined);
  return true;
});
wspr.S("web_request_submitted_raw", "analytics_init", async (wspr_event) => {
  const event = wspr_event.m;
  // we need to repeat to synthesise a thank you page as thats what the marketing people are used to.
  const allowed_request_types = new Set([
    "RAQ",
    "RAB",
    "RAC",
    "EMA",
    "SFO",
    "SFB",
    "TYP",
    "WEBQ",
    "WBBK",
    "WBOF.01",
    "WBOF.02",
    "WBOF.03",
    "WBOF.04"
  ]);
  if (!allowed_request_types.has(event.request_type)) {
    throw new Error(
      "Unexpected Request Type in web-request-submitted: " + event.request_type
    );
  }
  wspr.P("web_request_submitted", event);
  // these do not have a thank you page
  const stop_typ_trigger = new Set(["WBOF.01", "WBOF.02", "WBOF.03", "WBOF.04"]);
  if (!stop_typ_trigger.has(event.request_type)) {
    const typ_event = { ...event };
    typ_event.request_type = "TYP";
    wspr.P("web_request_submitted", typ_event);
  }
  return true;
});
wspr.S("liveperson:init", "analytics_init", (wspr_event) => {
  const event = wspr_event.m;
  wspr.P("liveperson_load", event);
  sv.log("LIVEPERSON -> liveperson:init", event.vid + " " + event.sid);

  lpTag.events.bind({
    appName: "lpUnifiedWindow",
    eventName: "state",
    func: function (data, eventInfo) {
      if(data.state === "init") {
        wspr.P("gtag", [
          "event",
          "liveperson_open",
          {
            send_to: "G-ZXCJY21NXY",
            liveperson_user_id: event.vid,
            liveperson_session_id: event.sid
          }
        ]);
        sv.log("LIVEPERSON state init", data.state);
      }
      if(data.state === "interactive") {
        wspr.P("gtag", [
          "event",
          "liveperson_interactive",
          {
            send_to: "G-ZXCJY21NXY",
            liveperson_user_id: event.vid,
            liveperson_session_id: event.sid
          }
        ]);
        sv.log("LIVEPERSON state interactive", data.state);
      }
      if(data.state === "chatting") {
        wspr.P("gtag", [
          "event",
          "liveperson_chatting",
          {
            send_to: "G-ZXCJY21NXY",
            liveperson_user_id: event.vid,
            liveperson_session_id: event.sid
          }
        ]);
        sv.log("LIVEPERSON state chatting", data.state);
      }
      if(data.state === "ended") {
        wspr.P("gtag", [
          "event",
          "liveperson_ended",
          {
            send_to: "G-ZXCJY21NXY",
            liveperson_user_id: event.vid,
            liveperson_session_id: event.sid
          }
        ]);
        sv.log("LIVEPERSON state ended", data.state);
      }
      // state log suspended due to event flooding
      // wspr.P("gtag", [
      //   "event",
      //   "liveperson_state",
      //   {
      //     send_to: "G-ZXCJY21NXY",
      //     liveperson_state: data.state
      //   }
      // ]);
      // sv.log("LIVEPERSON state", data.state);
    }
  });

  lpTag.events.bind({
    appName: "lpUnifiedWindow",
    eventName: "windowClosed",
    func: function (data, eventInfo) {
      wspr.P("gtag", [
        "event",
        "liveperson_closed",
        {
          send_to: "G-ZXCJY21NXY",
          liveperson_user_id: event.vid,
          liveperson_session_id: event.sid
        }
      ]);
      // state log suspended due to event flooding
      // wspr.P("gtag", [
      //   "event",
      //   "liveperson_state",
      //   {
      //     send_to: "G-ZXCJY21NXY",
      //     liveperson_state: "closed"
      //   }
      // ]);
      sv.log("LIVEPERSON state", data.state);
      sv.log("LIVEPERSON windowClosed", "");
    }
  });

  return true;
});
wspr.S("cruise_drawer_opened", "analytics_init", (wspr_event) => {
  const event = wspr_event.m;
  wspr.P("cruise_drawer_opened_int", event);
  sv.log("CRUISE DRAWER OPENED -> cruise_drawer_opened", event);
  return true;
});
wspr.S("web_request_submitted", "gtm_datalayer_events", async (wspr_event) => {
  const event = wspr_event.m;
  sv.trigger_event("conversion > " + event.request_type, event);
  return true;
});
wspr.S("click_interaction", "gtm_datalayer_events", async (wspr_event) => {
  sv.log("gtm_datalayer_events -> CLICK", "");
  const data_content_attribs = wspr_event.m;
  sv.trigger_event("data-track-content", data_content_attribs);
  return true;
});
wspr.S("cruise_filters_changed", "gtm_datalayer_events", (wspr_event) => {
  const event = wspr_event.m;
  const context = "cruise-filters-changed";
  sv.debug(context + " -> CRUISE_FILTER_CHANGED", event.detail);
  sv.trigger_event("cruise-filters-changed", event.detail);
  return true;
});

listen_for_dom_mutations();

window.OptanonWrapper = function () {
  // sv.trigger_event("OneTrustGroupsUpdated", undefined);
};

try {
  if (sv.get_cookie("OptanonAlertBoxClosed") == undefined) {
    sv.onetrust_consent.set_attitude("ignore");
    log("monitor_onetrust", "success");
  } else {
    log("monitor_onetrust", "already established.");
    try {
      if (sv.get_cookie("att") == undefined) {
        sv.onetrust_consent.set_attitude("unknown");
      }
    } catch (e) {
      console.error(e);
    }
  }
} catch (e) {
  // console.log("monitor_onetrust fail, re-scheduling...");
  // console.error("Issue with consent attitude: ", e);
}
